import * as yup from 'yup';

import { validators } from './utilities';

/**
 * Validation schema for Invoice Audit Analysis form fields
 */
export const invoiceAuditFieldSchema = {
  // Results file name
  fileName: yup.string().required('Results file name is required'),

  // Targeted carriers (required, at least 1, max 4)
  targetedCarriers: yup
    .array()
    .of(
      yup.object({
        label: yup.string().required(),
        value: yup.string().required(),
        carrier: yup.object({
          scac: yup.string().required(),
          name: yup.string().required(),
          tier: yup.string().required(),
        }).required(),
      })
    )
    .min(1, 'At least one carrier is required')
    .max(4, 'Maximum of 4 carriers allowed')
    .required('At least one carrier is required'),

  // Notification emails
  notifyEmails: yup
    .array(
      yup
        .object({
          value: validators.blugraceEmail.required(),
        })
        .required()
    )
    .required(),
};
